const ServiceName = {
  Code_Management: 'code-management',
  Evi_Categories: 'codeevidencecategory',
  Evi_Checkout_Location: 'codeevidencecheckoutlocation',
  Evi_Checkout_Reason: 'codeevidencecheckoutreason',
  Evi_Correction_Reason: 'codeevidencecorrectionreason',
  Evi_Custody_Reasons: 'codeevidencecustodyreason',
  Evi_Custody_Statuses: 'codeevidencecustodystatus',
  Evi_Destruction_Methods: 'codeevidencedestructionways',
  Evi_Disposal_Code: 'codeevidencedisposalcode',
  Evi_Drug_Types: 'codesuspecteddrugtypes',
  Evi_Field_Requirement_Setting: 'evid-field-requirement-setting',
  Evi_Final_Dispositions: 'codeevidencefinaldisposition',
  Evi_Party_Types: 'codepartyrelationship',
  Evi_Property_Types: 'codeevidencepropertytype',
  Evi_Required_Actions: 'codeevidencerequiredaction',
  Evi_Storage_Containers: 'codeevidencestoragecontainer',
  Evi_Storage_Locations: 'codeevidencestoragelocation',
  Evi_Sub_Storage_Location: 'codeevidencestoragesublocation',
  Evi_Substance_Categories: 'codesubstancecategory',
  Evi_Temporary_Locations: 'codeevidencetemporarylocation',
  Evi_Types: 'codeevidencetype',
  Evi_Units_Of_Measure: 'codedrugmeasurements',
  Evi_Evidence_Party: 'rms-evidence-party',
  Inc_Incident: 'incincident',
  Place_lookup: 'place-lookup',
  Address_lookup: 'address-lookup',
  ptsPerson: 'ptsperson',
  CadSearchPeople: 'cad-search-people',
  CadHistoryEditAddress: 'cad-history-edit-address',
  CityManagement: 'city-management',
  Cdr: 'cdr',
  RmsAddressDuplicates: 'rms-address-duplicates',
  RecordPersonName: 'record-person-name',
  RecordPersonContact: 'record-person-contact',
  RecordPersonCredentials: 'record-person-credentials',
  RecordPersonEmployment: 'record-person-employment',
  CadSearchPeopleEmployment: 'cad-search-people-employment',
  RecordPersonFeature: 'record-person-feature',
  CadPersonFeatures: 'cad-person-features',
  CadPersonDnaSamples: 'cad-person-dna-samples',
  CadPersonAssociate: 'cad-person-associate',
  RecordPersonAssociates: 'record-person-associates',
  VehicleLookup: 'vehicle-lookup',
  CadSearchVehicles: 'cad-search-vehicles',
  CadPtsVehicle: 'cad-pts-vehicle',
  CadVehicleTowing: 'cad-vehicle-towing',
  CadSearchPlaces: 'cad-search-places',
  RecordPersonVehicleRegistration: 'record-person-vehicle-registration',
  CadPtsVehicleReg: 'cad-pts-vehicle-reg',
  CadSearchPlaceAddress: 'cad-search-place-address',
  CadSearchAddresses: 'cad-search-addresses',
  RecordPersonAddress: 'record-person-address',
  ptsAddress: 'ptsaddress',
  Cad: 'cad',
  PtsZoneInfo: 'ptszoneinfo',
  CadAddressCoordinates: 'cad-address-coordinates',
  CadAddressPtsCoordinateID: 'cad-address-pts-coordinate-id',
  CadAddressHistory: 'cad-address-history',
  CadAddressParties: 'cad-address-parties',
  CadSearchWarrants: 'cad-search-warrants',
  CadAddressPrePlan: 'cad-address-pre-plan',
  CadAddressPrePlanInspections: 'cad-address-pre-plan-inspections',
  RmsTagsV2: 'rms-tags-v2',
  CadPersonPhoto: 'cad-person-photo',
  CadUploadPersonPhoto: 'cad-upload-person-photo',
  CadAlerts: 'cad-alerts',
  CadSearchAlerts: 'cad-search-alerts',
  SearchPersonRelatedRecord: 'search-person-related-record',
  PtsSops: 'ptssops',
  RecordPersonSops: 'record-person-sops',
  RmsAssignedSops: 'rms-assigned-sops',
  ptsPlace: 'ptsplace',
  Places: 'places',
  CadPlaceAddress: 'cad-place-address',
  PtsVehicleReg: 'ptsvehiclereg',
  ptsStatute: 'ptsStatute ',
  rms_evidence_detail: 'rms-evidence-detail',
  rms_evidence_helper: 'rms-evidence-helper',
  rms_evidence_notes: 'rms-evidence-notes',
  rms_evidence_correction: 'rms-evidence-corr-request',
  secClearanceLevel: 'secclearancelevel',
  rms_evidence_records: 'rms-evidence-records',
  rms_user_grid_layout: 'rms-grid-layout-user-specific',
  rms_evidence_corr_request: 'rms-evidence-corr-request',
  rms_evidence_storage: 'rms-evidence-storage',
  rms_attachments: 'rms-attachments',
  code_rap_value: 'coderepvalues',
  rms_party: 'rms-evidence-party',
  rms_evidence_checkout_request: 'rms-evidence-checkout-request',
  cad_attachments: 'cad-attachments',
  rms_evidence_custody: 'rms-evidence-custody',
  rms_evidence_party_v2: 'rms-evidence-party-v2',
  evidence_audit_temp: 'evidence-audit-temp',
  evidence_audit: 'evidence-audit',
  settings_agency_rms: 'settings-agency-rms',
  RMS_Evidence_Audit_OverDueDay: '.RMS.Evidence.Audit.OverDueDay',
  rms_evidence_report_header: 'rms-evidence-reportheader',
  rms_scheduled_reports_settings: 'rms-scheduled-reports-settings',
  rms_scheduled_reports_preview: 'rms-scheduled-reports-preview',
  rms_scheduled_reports_send: 'rms-scheduled-reports-send',
  rms_evidence_disposal_rules: 'rms-evidence-disposal-rules',
  rms_user_signature: 'rms-user-signature',
  rms_evidence_custody_signature: 'rms-evidence-custody-signature',
  Evidence_Select_Labels: 'rms-evidence-select-labels',
  rms_attachment_share: 'rms-attachment-share',
  rms_attachment_share_bundle: 'rms-attachment-share-bundle',
  rms_ibrs_incident: 'rms-ibrs-incident',
  rms_create_report: 'rms-create-report',
};

export default ServiceName;
